import { CartViewEvent } from '@/usecases/event-bus-for-third-party/event'

export function handleCartViewEvent(event: CartViewEvent): void {
  /**
   * CyberACE用
   * このイベントは送信なくて良いかも知れない
   * - CyberACEは過去SMbrandで契約していたが、現在は契約解除しているはずなので送信しなくていいかも
   * - MyColor以外のホストでも送信しているが、参照されていないことが確認できれば送信しなくていいかも
   *
   * @see https://my-color.esa.io/posts/1259
   * @see https://github.com/Everforth/growthpalette-front/issues/8144
   */
  window.dataLayer.push({
    event: 'addToCart',
    ecommerce: {
      add: {
        products: event.wholeItems.map(cartItem => ({
          id: cartItem.skuId,
          // ショートIDとロングIDの併用については @link https://github.com/my-color/front/pull/6453#issuecomment-1127426043
          short_id: cartItem.skuShortId,
          name: cartItem.name,
          price: cartItem.unitPrice,
          brand: cartItem.brandEnglishName || '',
          category: cartItem.categories.map(c => c.pathname).join(','),
          quantity: cartItem.unitCount,
        })),
      },
    },
  })
}
